import {FC} from 'react';

import s from '../styles.module.scss';

interface ContactUsFinishProps {
  siteName: string;
}

export const ContactUsFinish: FC<ContactUsFinishProps> = ({siteName}) => (
  <div className={s['contact-us-result']}>
    <p className={s['contact-us-result__header']}>Thank you for contacting {siteName}.</p>
    <p className={s['contact-us-result__p']}>
      Your request has been received and is being reviewed.
    </p>
  </div>
);
